import './styles.scss';
import React, {Dispatch, useEffect, useState} from "react";

/* Types, Constants, Utils */
import {TFilterOption} from "../../../types/search";
import * as Constants from "../../../constants";
import Utils from "../../../utils";

/* redux */
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux";
import {ISearchState} from "../../../types/redux/search";
import {AnyAction} from "@reduxjs/toolkit";

/* Bootstrap */
import {Form} from "react-bootstrap";
import {FormCheckType} from "react-bootstrap/FormCheck";
import {addRemoveSelectedFilters} from "../../../redux/slices/search-slice";

interface IProps {
  onHandleChange?: (selectedOption: TFilterOption)=>void | null;
  type: FormCheckType;
  filterOption: TFilterOption;
}

const FiltersCheck = (props: IProps):JSX.Element => {
  const {
    type,
    filterOption,
    onHandleChange
  } = props;

  const [selected, setSelected] = useState<boolean>(false);
  const searchState: ISearchState = useSelector<RootState, ISearchState>((state: RootState):any => state.search);
  const dispatch:Dispatch<AnyAction> = useDispatch();

  useEffect(()=> {
    const mouseDownListener = (e: MouseEvent): void => e.stopPropagation();
    document.addEventListener('mousedown', mouseDownListener);

    return () => {
      document.removeEventListener('mousedown', mouseDownListener);
    }
  },[])

  useEffect(()=>{
    setSelected(searchState.selected_filters_ids.indexOf(filterOption.id) !== -1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOption, searchState.selected_filters_ids]); /* onHandleChange forces update on external selection set */

  const handleToggle = (e:React.MouseEvent, isClick:boolean): void =>{
    e.stopPropagation();
    if (!isClick) {
      e.preventDefault();
    }

    const toggled: boolean = !selected;
    setSelected(toggled);

    if (onHandleChange) {
      onHandleChange({...filterOption});
    } else {
      dispatch(addRemoveSelectedFilters({ids: [filterOption.id], method: toggled ? Constants.ADD : Constants.REMOVE}))
    }
  };

  return (
    <Form.Group controlId={filterOption.id + '_controller' } key={filterOption.id + '_fg'}>
      <Form.Check
        key={filterOption.id + '_check'}
        className={'filters-checkbox text-larger mt-1 mb-2'}
        type={type}
        label={<span onClick={e=>handleToggle(e, false)} role={'button'} className={'text-smaller'}>
          <div className={'d-inline-block pt-2'}  key={filterOption.id + '_check2'} >{filterOption.label}</div>
                {filterOption.count &&
                  <span className={'ms-1 text-smaller'}>({Utils.formatNumber(filterOption.count)})</span>}
              </span>}
        onChange={()=>{}}
        checked={selected}
        onClick={e=>handleToggle(e, true)}
      />
    </Form.Group>
  )
}
export default FiltersCheck;
